import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function PillCloudTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-relaxed" data-testid="resume-live-preview">
      <h1 className="text-2xl font-bold">{draft.full_name || "Your Name"}</h1>
      {draft.target_role && <p className="text-sm font-semibold mt-0.5" style={{ color: accent }}>{draft.target_role}</p>}
      <p className="text-slate-500 text-[11px] mt-2">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  •  ")}</p>

      {draft.summary && <p className="text-slate-700 mt-4 mb-4">{draft.summary}</p>}

      {draft.skills.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Skills</h2>
          <div className="flex flex-wrap gap-1.5">
            {draft.skills.map((sk, i) => (
              <span key={sk} className="text-[11px] font-medium px-2.5 py-1 rounded-full" style={{ backgroundColor: `${accent}${i % 3 === 0 ? "30" : i % 3 === 1 ? "1f" : "12"}`, color: "#1e293b" }}>{sk}</span>
            ))}
          </div>
        </div>
      )}
      {draft.experience.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mb-2.5">
              <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
